/**
 * Centralized mapping from backend entity names to onboarding step routes.
 *
 * When the backend introduces a new entity name, add a single entry here
 * rather than scattering knowledge across components.
 */

/** Maps every known backend entity name to its onboarding stepper route. */
export const ENTITY_TO_STEP_ROUTE: Readonly<Record<string, string>> = {
  // Step 1 — Legal Entity
  LegalEntityProfile: 'legal-entity',

  // Step 2 — Contact & Address
  LegalEntityContact: 'contact-address',

  // Step 3 — Controlling Persons
  ControllingPersonAssociation: 'controlling-persons',

  // Step 4 — Directors & Executives
  DirectorExecutiveAssociation: 'directors-executives',

  // Step 5 — Authorized Persons
  AuthorizedPersonAssociation: 'authorized-persons',

  // Step 6 — PEP Declarations
  PepDeclaration: 'pep-declarations',

  // Step 7 — Bank & Custodian
  LegalEntityBankCustodian: 'bank-custodian',

  // Step 8 — Investment Profile
  LegalEntityInvestmentProfile: 'investment-profile',

  // Step 9 — FATCA / CRS
  FatcaCrsProfile: 'fatca-crs',
  FatcaCrsControllingPerson: 'fatca-crs',
  CrsTaxResidency: 'fatca-crs',

  // Step 10 — Documents
  ApplicationDocument: 'documents',
  EntityDocument: 'documents',
  PersonDocument: 'documents',

  // Step 11 — Signed Documents
  SignedDocument: 'signed-documents',

  // Assessment step — completeness API entity names
  LegalEntityAssessment: 'assessment',
  IndividualAssessment: 'assessment',
  Assessment: 'assessment',
  IsSignedAssessmentVerified: 'assessment',
};

/**
 * Look up the onboarding step route for a given backend entity name.
 * Returns `null` when the entity is unknown — callers should skip those.
 */
export function resolveStepRoute(entityName: string): string | null {
  return ENTITY_TO_STEP_ROUTE[entityName] ?? null;
}
